import React, { useState, useEffect, useRef } from "react";
import emailjs from '@emailjs/browser';

function ContactSection() {
    const [form, setForm] = useState({
        first: "",
        last: "",
        email: "",
        subject: "",
        message: "",
    });
    const [submitted, setSubmitted] = useState(false);
    const [fadeIn, setFadeIn] = useState(false);
    const sectionRef = useRef(null);

    function handleChange(e) {
        setForm({ ...form, [e.target.name]: e.target.value });
    }

    function handleSubmit(e) {
        e.preventDefault();

        // 1. Create a FormData object from the form
        const formData = new FormData(e.target);

        // 2. Convert it to a plain object
        const formValues = Object.fromEntries(formData.entries());

        // console.log(formValues); 
        // Output: { first: "test", last: "test", company: "test", ... }

        const payload = {
			from_name: `${formValues.first} ${formValues.last}`,
			subject: formValues.subject,
			message: formValues.message,
			reply_to: formValues.email,
		};

        console.log(payload); 
 
        emailjs.send("service_7494v3g", "template_dc6t6wa", payload, "8sC5aaAA5yrWJeXul").then(
			(result) => {
				console.log("SUCCESS send", result.text);
				alert("Thank you for your contacting us. Your email was sent. We will reply to you as soon as possible.");
				window.location.reload();
			},
			(error) => {
				console.log("FAILED...", error.text);
			}
		);

        setSubmitted(true);
    }

    useEffect(() => {
        const target = sectionRef.current; // capture the current ref
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setFadeIn(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.3 },
        );

        if (target) {
            observer.observe(target);
        }

        return () => {
            if (target) observer.unobserve(target); // use captured value
            observer.disconnect();
        };
    }, []);

    return (
        <section id="contact" ref={sectionRef} className={`contact-bg ${fadeIn ? "fade-in" : ""}`}>
            <div className="contact-grid">
                <div className="contact-left">
                    <h3>
                        CONTACT
                        <br />
                        California Framing
                    </h3>
                    <div className="contact-address">
                        <div style={{fontSize:'larger'}}>Ready to start your project? Contact California Framing for reliable, high-quality structural framing services. We respond quickly and keep your project moving forward with precision and efficiency.</div>
                        {/* TODO: Add Google maps link  */}
                        {/* <a className="contact-link" href="/">
                            Click Here to Find Us
                        </a> */}
                    </div>
                </div>

                <div className="contact-right">
                    <form className="contact-form" onSubmit={handleSubmit} autoComplete="off">
                        <div className="contact-row">
                            <input type="text" name="first" placeholder="First Name*" required value={form.first} onChange={handleChange} />
                            <input type="text" name="last" placeholder="Last Name*" required value={form.last} onChange={handleChange} />
                        </div>
                        <input type="email" name="email" placeholder="Email*" required value={form.email} onChange={handleChange} />
                        <input type="text" name="subject" placeholder="Subject*" required value={form.subject} onChange={handleChange} />
                        <textarea name="message" placeholder="Message*" required value={form.message} onChange={handleChange} rows={5} />
                        <button className="contact-submit" type="submit">
                            Submit
                        </button>
                        {submitted && <div className="contact-success">Thank you! We'll be in touch soon.</div>}
                    </form>
                </div>
            </div>
        </section>
    );
}

export default ContactSection;
